<app-form></app-form>
<ng-container *ngIf="isLoading$() | async">
    <div class="loading-overlay">
        <mat-spinner color="accent"></mat-spinner>
    </div>
</ng-container>